"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Navigation_1 = __importStar(require("Common/Navigation/Navigation"));
var inversify_react_1 = require("inversify-react");
var OpenBrandSetup_1 = __importDefault(require("DreamCoat/BrandSetUp/OpenBrandSetup"));
var NavHomeButtons_1 = require("Common/Navigation/NavHomeButtons");
exports.default = (function (mountReactComponent, invoke, $state) {
    var openBrandSetup = invoke(OpenBrandSetup_1.default);
    return mountReactComponent(react_1.default.createElement(AnalyticsNavigation, { openBrandSetup: openBrandSetup, "$state": $state }));
});
var AnalyticsNavigation = function (_a) {
    var openBrandSetup = _a.openBrandSetup, $state = _a.$state;
    var user = (0, inversify_react_1.useInjection)("user");
    var telemetry = (0, inversify_react_1.useInjection)("telemetry");
    var rolesService = (0, inversify_react_1.useInjection)("rolesService");
    var publicApiBaseUrl = (0, inversify_react_1.useInjection)("publicApiBaseUrl");
    return (react_1.default.createElement(Navigation_1.default, { pageName: Navigation_1.PageName.Analytics, user: user, "$state": $state, openBrandSetup: openBrandSetup, publicApiBaseUrl: publicApiBaseUrl, telemetry: telemetry, rolesService: rolesService },
        react_1.default.createElement(NavHomeButtons_1.NavHomeButtons, { "$state": $state, hideBlocksButton: false, activeNav: "analytics", user: user, rolesService: rolesService })));
};
